const tokenKey = 'vue_admin_token'
const lmKey = 'vue_menu_loaded'

export function getToken() {
  return sessionStorage.getItem(tokenKey)
}

export function setToken(token) {
  return sessionStorage.setItem(tokenKey, token)
}

export function removeToken() {
  return sessionStorage.removeItem(tokenKey)
}


export function getLoadedMenu() {
  return sessionStorage.getItem(lmKey)
}
export function setLoadedMenu() {
  return sessionStorage.setItem(lmKey,1)
}